import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { MastersState, CreateVanchiNameRequest } from '../../types';
import { vanchiNameService } from '../../services/vanchiNameService';

// Initial state
const initialState: MastersState = {
  nada: [],
  vanchiNames: [],
  total: 0,
  loading: false,
  error: null,
};

// Async thunks





export const fetchVanchiNames = createAsyncThunk(
  'masters/fetchVanchiNames',
  async (_, { rejectWithValue }) => {
    try {
      const response = await vanchiNameService.getVanchiNames();
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch vanchi names');
    }
  }
);


export const updateVanchiName = createAsyncThunk(
  'masters/updateVanchiName',
  async ({ id, data, existingRowData, nadaList, userId, isVanchiNoForm }: { id: string; data: Partial<CreateVanchiNameRequest>; existingRowData: any; nadaList?: any[]; userId?: string; isVanchiNoForm?: boolean }, { rejectWithValue }) => {
    try {
      const updatedVanchiName = await vanchiNameService.updateVanchiName(id, data, existingRowData, nadaList, userId, isVanchiNoForm);
      return updatedVanchiName;
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to update vanchi name');
    }
  }
);





// Slice
const mastersSlice = createSlice({
  name: 'masters',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch vanchi names
      .addCase(fetchVanchiNames.fulfilled, (state, action) => {
        state.vanchiNames = action.payload.data || [];
        state.total = action.payload.rowCount || state.vanchiNames.length;
      })
      // Update vanchi name
      .addCase(updateVanchiName.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateVanchiName.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.vanchiNames.findIndex((vanchiName: any) => vanchiName.tblid === action.payload.tblid);
        if (index !== -1) {
          state.vanchiNames[index] = action.payload;
        }
      })
      .addCase(updateVanchiName.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError, setLoading } = mastersSlice.actions;
export default mastersSlice.reducer;
